<button  (click)="onClick()"  class="{{bgColor}}">
    <p id="text">{{label}}</p>
</button>